import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import base64 from 'base-64';

const InviteOthers = props => {
  let invitesLink;

  if (props.basePath && props.inviteUrl) {
    invitesLink = `${props.basePath}/invites/${base64.encode(props.inviteUrl)}`;
  }

  return (
    <section className="site-width">
      {props.showVideoUpload ? (
        <h3>{props.translations['want-to-invite-others']}</h3>
      ) : (
        <p>{props.translations['want-to-invite-others']}</p>
      )}
      <Link // eslint-disable-line
        id="invite-others"
        className="btn"
        style={{ backgroundColor: props.color }}
        to={`${invitesLink}`}
      >
        {props.translations['invite-commenters']}
      </Link>
    </section>
  );
};

InviteOthers.propTypes = {
  translations: PropTypes.objectOf(PropTypes.string).isRequired,
  color: PropTypes.string.isRequired,
  inviteUrl: PropTypes.string.isRequired,
  basePath: PropTypes.string.isRequired,
  showVideoUpload: PropTypes.bool.isRequired,
};

export default InviteOthers;
